// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AutomateProcess_componentArrangement__sXnpU {
  margin-top: 105px;
}
@media only screen and (max-width: 767.98px) {
  .AutomateProcess_componentArrangement__sXnpU {
    margin-top: 45px;
  }
}

.AutomateProcess_automateHeading__8q0qm {
  color: #333;
  font-family: "Roboto";
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 60px;
}
@media only screen and (max-width: 767.98px) {
  .AutomateProcess_automateHeading__8q0qm {
    color: #333;
    font-family: "Roboto";
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    width: 90%;
    margin-left: 10px;
  }
}

.AutomateProcess_automatePara__ma4aI {
  color: #666;
  font-family: "Roboto";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 25px;
  width: 110%;
  margin-top: 34px;
}
@media only screen and (max-width: 767.98px) {
  .AutomateProcess_automatePara__ma4aI {
    color: #666;
    font-family: "Roboto";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    margin-top: 15px;
    margin-bottom: 10px;
    margin-left: 10px;
    width: 90%;
  }
}

.AutomateProcess_learnButtonBoxMannagement__19rAE {
  width: 160px !important;
  height: 56px;
  border-radius: 4px;
  border: 1px solid #5b7cfd;
  padding-bottom: 53px;
  margin-top: 39px;
}

@media only screen and (max-width: 767.98px) {
  .AutomateProcess_learnButtonBoxMannagement__19rAE {
    width: 90% !important;
    height: 40px !important;
    border-radius: 4px;
    border: 1px solid #5b7cfd;
    margin: 0 auto;
    margin-top: 15px;
  }
}

.AutomateProcess_learnButtonCoustomText__pjNT9 {
  color: #5b7cfd;
  text-align: center;
  font-family: "Roboto";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 18px;
}

.AutomateProcess_moneyMannageIcon__Azwb4 {
  width: 64px;
  height: 64px;
}
@media only screen and (max-width: 767.98px) {
  .AutomateProcess_moneyMannageIcon__Azwb4 {
    width: 64px;
    height: 64px;
    margin-left: auto;
    margin-right: auto;
  }
}

.AutomateProcess_itemHeadingAndDiscription__eqhsp {
  margin-left: 0px;
}
@media only screen and (max-width: 767.98px) {
  .AutomateProcess_itemHeadingAndDiscription__eqhsp {
    margin-left: 0px;
    margin-top: 15px;
  }
}

.AutomateProcess_moneyMannageItemHeading__TG6kc {
  color: #333;
  font-family: "Roboto";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
@media only screen and (max-width: 767.98px) {
  .AutomateProcess_moneyMannageItemHeading__TG6kc {
    text-align: center;
    width: 70%;
    margin: 0 auto;
    font-weight: 600;
  }
}

.AutomateProcess_moneyMannageDiscription__cKVEy {
  color: #666;
  font-family: "Roboto";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 25px;
  margin-top: 21px;
  width: 358px;
}
@media only screen and (max-width: 767.98px) {
  .AutomateProcess_moneyMannageDiscription__cKVEy {
    text-align: center;
    font-size: 16px;
    line-height: 20px;
    width: 98%;
    margin: 0 auto;
    margin-top: 10px;
    margin-bottom: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Homepage/MudasirScreens/HRManagement/components/AutomateProcess/AutomateProcess.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE;IACE,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,iBAAiB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE;IACE,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,UAAU;EACZ;AACF;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE;IACE,qBAAqB;IACrB,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE;IACE,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;AACF","sourcesContent":[".componentArrangement {\n  margin-top: 105px;\n}\n@media only screen and (max-width: 767.98px) {\n  .componentArrangement {\n    margin-top: 45px;\n  }\n}\n\n.automateHeading {\n  color: #333;\n  font-family: \"Roboto\";\n  font-size: 40px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 60px;\n}\n@media only screen and (max-width: 767.98px) {\n  .automateHeading {\n    color: #333;\n    font-family: \"Roboto\";\n    font-size: 32px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    width: 90%;\n    margin-left: 10px;\n  }\n}\n\n.automatePara {\n  color: #666;\n  font-family: \"Roboto\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 25px;\n  width: 110%;\n  margin-top: 34px;\n}\n@media only screen and (max-width: 767.98px) {\n  .automatePara {\n    color: #666;\n    font-family: \"Roboto\";\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 22px;\n    margin-top: 15px;\n    margin-bottom: 10px;\n    margin-left: 10px;\n    width: 90%;\n  }\n}\n\n.learnButtonBoxMannagement {\n  width: 160px !important;\n  height: 56px;\n  border-radius: 4px;\n  border: 1px solid #5b7cfd;\n  padding-bottom: 53px;\n  margin-top: 39px;\n}\n\n@media only screen and (max-width: 767.98px) {\n  .learnButtonBoxMannagement {\n    width: 90% !important;\n    height: 40px !important;\n    border-radius: 4px;\n    border: 1px solid #5b7cfd;\n    margin: 0 auto;\n    margin-top: 15px;\n  }\n}\n\n.learnButtonCoustomText {\n  color: #5b7cfd;\n  text-align: center;\n  font-family: \"Roboto\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin-top: 18px;\n}\n\n.moneyMannageIcon {\n  width: 64px;\n  height: 64px;\n}\n@media only screen and (max-width: 767.98px) {\n  .moneyMannageIcon {\n    width: 64px;\n    height: 64px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n\n.itemHeadingAndDiscription {\n  margin-left: 0px;\n}\n@media only screen and (max-width: 767.98px) {\n  .itemHeadingAndDiscription {\n    margin-left: 0px;\n    margin-top: 15px;\n  }\n}\n\n.moneyMannageItemHeading {\n  color: #333;\n  font-family: \"Roboto\";\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n@media only screen and (max-width: 767.98px) {\n  .moneyMannageItemHeading {\n    text-align: center;\n    width: 70%;\n    margin: 0 auto;\n    font-weight: 600;\n  }\n}\n\n.moneyMannageDiscription {\n  color: #666;\n  font-family: \"Roboto\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 25px;\n  margin-top: 21px;\n  width: 358px;\n}\n@media only screen and (max-width: 767.98px) {\n  .moneyMannageDiscription {\n    text-align: center;\n    font-size: 16px;\n    line-height: 20px;\n    width: 98%;\n    margin: 0 auto;\n    margin-top: 10px;\n    margin-bottom: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"componentArrangement": `AutomateProcess_componentArrangement__sXnpU`,
	"automateHeading": `AutomateProcess_automateHeading__8q0qm`,
	"automatePara": `AutomateProcess_automatePara__ma4aI`,
	"learnButtonBoxMannagement": `AutomateProcess_learnButtonBoxMannagement__19rAE`,
	"learnButtonCoustomText": `AutomateProcess_learnButtonCoustomText__pjNT9`,
	"moneyMannageIcon": `AutomateProcess_moneyMannageIcon__Azwb4`,
	"itemHeadingAndDiscription": `AutomateProcess_itemHeadingAndDiscription__eqhsp`,
	"moneyMannageItemHeading": `AutomateProcess_moneyMannageItemHeading__TG6kc`,
	"moneyMannageDiscription": `AutomateProcess_moneyMannageDiscription__cKVEy`
};
export default ___CSS_LOADER_EXPORT___;
